/** Royalty-free loop used to simulate stream in Tuner Demo Mode. */
export const DEMO_AUDIO_STREAM_URL =
  "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3";

/** Fallback listener heartbeat ping interval (seconds). */
export const HEARTBEAT_INTERVAL_SECONDS = 15;

/** Polling interval for broadcast status, listener-side (seconds). */
export const STATUS_POLL_INTERVAL_SECONDS = 10;

/**
 * Status poll cadence while broadcasting locally (seconds). Keeps the listener
 * count fresh; the SFU is never probed in this mode (local connection state is
 * authoritative and event-driven).
 */
export const STATUS_POLL_BROADCASTING_SECONDS = 20;

/**
 * Status poll cadence while idle (seconds). The only time the SFU probe runs —
 * to detect an orphaned/stale server session worth force-clearing.
 */
export const STATUS_POLL_IDLE_SECONDS = 30;

/** Resolved API base URL (empty = same-origin relative). */
export function apiBaseUrl(): string {
  const defineUrl = import.meta.env.VITE_API_URL;
  if (defineUrl && defineUrl.length > 0) {
    return defineUrl.endsWith("/") ? defineUrl.slice(0, -1) : defineUrl;
  }
  return "";
}
